import type { BookstackContentTypes, BookstackSearchResult } from '@/types/bookstackTypes'

export async function bookstackQuery(
  query: string,
  options?: {
    tags?: string[]
    exactMatches?: string[]
    contentTypes?: BookstackContentTypes[]
    count?: number
  }
) {
  const { tags, exactMatches, contentTypes, count } = options || {}

  let queryString = query

  if (tags && tags.length) {
    queryString += ' ' + tags.map((tag) => `[${tag}]`).join(' ')
  }
  if (exactMatches && exactMatches.length) {
    queryString += ' ' + exactMatches.map((match) => `"${match}"`).join(' ')
  }
  if (contentTypes && contentTypes.length) {
    queryString += ' ' + `{type:${contentTypes.join('|')}}`
  }

  queryString = queryString.trim()

  const queryParams = new URLSearchParams()
  queryParams.append('query', queryString)
  if (count) queryParams.append('count', `${count}`)

  const response = await fetch(`/api/Bookstack/search?${queryParams}`)
  if (!response.ok) return []

  const data = (await response.json()) as BookstackSearchResult[]

  return data
}
